import { GoogleMap, GoogleMapProps } from '@react-google-maps/api'
import AppLoader from 'components/AppLoader'
import useGoogleMaps from 'hooks/useGoogleMaps'
import React, { CSSProperties, ReactNode, useMemo } from 'react'

export interface AppMapProps extends GoogleMapProps {
  children: ReactNode
  style?: CSSProperties
}

const AppMap = ({ style, ...rest }: AppMapProps) => {
  const { isLoaded, loadError } = useGoogleMaps()

  const containerStyle = useMemo(() => style ?? defaultContainerStyle, [style])

  if (!isLoaded) {
    return (
      <div style={containerStyle}>
        <AppLoader />
      </div>
    )
  }

  if (loadError) {
    return <div style={containerStyle}>{loadError.message}</div>
  }

  return <GoogleMap mapContainerStyle={containerStyle} {...rest} />
}

const defaultContainerStyle: CSSProperties = {
  height: '700px'
}

export default AppMap
